module.exports = __webpack_public_path__ + "img/bostonh3logo.66e07c4b.jpg";